let wasShowInputListenerSet = false;
let wasCodeAddedFromInput = false;
const DISCOUNT_BREAKDOWN_MODAL_ID = 'smart-cart-discount-breakdown-modal';
const DISCOUNT_BREAKDOWN_BUTTON_ID = 'smart-cart-discount-breakdown-button';
const excludedDiscountTitles = [window.ykCartPromoBadge?.discountTitle].filter(Boolean);

const collapseCartSummaryHandler = () => {
  const summary = document.getElementById('yk-smart-cart-summary');
  const contentWrapper = document.getElementById('flyout-cart-content');
  const cube = document.getElementById('cube');

  if (!summary || !contentWrapper || !cube) return;

  const temp = contentWrapper.scrollHeight - contentWrapper.offsetHeight - 75;
  const isBottom = contentWrapper.scrollTop > temp;
  summary.classList[isBottom ? 'add' : 'remove']('extended');

  if (!isBottom) {
    cube.style.transform = 'translateY(0)';
  } else {
    cube.style.transform = 'translateY(-33px)';
  }
};

const formatPriceForDiscount = (price) => {
  price = (price / 100).toFixed(2);
  return new Intl.NumberFormat('pl-PL', {
    style: 'currency',
    currency: 'PLN',
  }).format(price);
};

const toNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const parseMoneyStringToCents = (value) => {
  if (typeof value !== 'string') return null;

  const normalized = value.replace(',', '.').trim();
  if (!normalized) return null;

  const parsed = Number(normalized);
  if (!Number.isFinite(parsed) || parsed <= 0) return null;

  return Math.round(parsed * 100);
};

const parseAnyMoneyToCents = (value) => {
  if (typeof value === 'string') return parseMoneyStringToCents(value);

  if (typeof value === 'number' && Number.isFinite(value) && value > 0) {
    return value > 1000 ? Math.round(value) : Math.round(value * 100);
  }

  return null;
};

const getItemPropertyValue = (item, key) => {
  const properties = item?.properties;
  if (!properties || !key) return null;

  if (Array.isArray(properties)) {
    const found = properties.find((entry) => {
      const entryKey = String(entry?.name || entry?.key || '').trim();
      return entryKey === key;
    });
    return found?.value ?? null;
  }

  if (typeof properties === 'object') {
    return properties[key] ?? null;
  }

  return null;
};

const getComponentsDiscountAmount = (item) => {
  if (!item?.has_components) return 0;

  const originalUnitPrice = parseMoneyStringToCents(String(getItemPropertyValue(item, '_originalPrice') || ''));
  const currentUnitPrice = parseAnyMoneyToCents(item?.price);
  const quantity = Math.max(1, toNumber(item?.quantity));

  if (!originalUnitPrice || !currentUnitPrice || originalUnitPrice <= currentUnitPrice) return 0;

  return (originalUnitPrice - currentUnitPrice) * quantity;
};

const getItemVariant = (item) => {
  const variants = item?.product?.variants;
  if (!Array.isArray(variants) || variants.length === 0) return null;

  const itemVariantId = toNumber(item?.variant_id);
  return variants.find((variant) => toNumber(variant?.id) === itemVariantId) || null;
};

const getDiscountCodeAmount = (item) => {
  if (!Array.isArray(item?.discounts)) return 0;

  return item.discounts.reduce((sum, discount) => {
    if (!discount || excludedDiscountTitles.includes(discount.title)) return sum;
    const amount = toNumber(discount.amount);
    return sum + (amount > 0 ? amount : 0);
  }, 0);
};

const getItemDiscountBreakdown = (item) => {
  const quantity = Math.max(1, toNumber(item?.quantity));
  const variant = getItemVariant(item);
  const sellingPlan = item?.selling_plan_allocation || null;
  const isSubscription = Boolean(sellingPlan);

  if (!variant) {
    return {
      compareAtDiscount: 0,
      subscriptionDiscount: 0,
      promoCodeDiscount: getDiscountCodeAmount(item),
    };
  }

  const variantCompareAtStringCents = parseMoneyStringToCents(variant.compare_at_price);
  const variantOneTimePriceCents = parseAnyMoneyToCents(variant.price);

  let compareAtDiscount = 0;
  if (
    variantCompareAtStringCents &&
    variantOneTimePriceCents &&
    variantCompareAtStringCents > variantOneTimePriceCents
  ) {
    compareAtDiscount = (variantCompareAtStringCents - variantOneTimePriceCents) * quantity;
  }

  compareAtDiscount += getComponentsDiscountAmount(item);

  let subscriptionDiscount = 0;
  if (isSubscription) {
    const oneTimeBase = variantOneTimePriceCents || toNumber(sellingPlan?.compare_at_price);
    const subscriptionUnitPrice = toNumber(sellingPlan?.price || sellingPlan?.per_delivery_price);

    if (oneTimeBase > 0 && subscriptionUnitPrice > 0 && oneTimeBase > subscriptionUnitPrice) {
      subscriptionDiscount = (oneTimeBase - subscriptionUnitPrice) * quantity;
    }
  }

  return {
    compareAtDiscount: Math.max(compareAtDiscount, 0),
    subscriptionDiscount: Math.max(subscriptionDiscount, 0),
    promoCodeDiscount: Math.max(getDiscountCodeAmount(item), 0),
  };
};

const getCartDiscountBreakdown = (items) => {
  return items.reduce(
    (acc, item) => {
      const itemDiscount = getItemDiscountBreakdown(item);

      acc.compareAtDiscount += itemDiscount.compareAtDiscount;
      acc.subscriptionDiscount += itemDiscount.subscriptionDiscount;
      acc.promoCodeDiscount += itemDiscount.promoCodeDiscount;

      return acc;
    },
    {
      compareAtDiscount: 0,
      subscriptionDiscount: 0,
      promoCodeDiscount: 0,
    }
  );
};

const ensureDiscountBreakdownModal = () => {
  let modal = document.getElementById(DISCOUNT_BREAKDOWN_MODAL_ID);
  if (modal) return modal;

  modal = document.createElement('div');
  modal.id = DISCOUNT_BREAKDOWN_MODAL_ID;
  modal.style.position = 'fixed';
  modal.style.inset = '0';
  modal.style.zIndex = '9999999999';
  modal.style.display = 'none';
  modal.style.alignItems = 'center';
  modal.style.justifyContent = 'center';
  modal.innerHTML = `
    <style>
      #${DISCOUNT_BREAKDOWN_MODAL_ID} [data-modal-close="overlay"] {
        background: rgba(116, 116, 116, 0.9);
      }

      @media (min-width: 1025px) {
        #${DISCOUNT_BREAKDOWN_MODAL_ID} [data-modal-close="overlay"] {
          background: transparent;
        }
      }
    </style>
    <div data-modal-close="overlay"
    class="absolute inset-0"
    ></div>
    <div 
    class="relative bg-white py-10 px-6 max-w-sm mx-auto rounded-lg w-[min(92vw,420px)]">
      <button type="button" data-modal-close="button" class="absolute pointer top-[18px] right-[18px]">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
          <path d="M12.5 0.5L0.5 12.5M0.5 0.5L12.5 12.5" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
      </button>
      <div class="mb-5 font-semibold text-sm flex items-center gap-1.5">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
          <path d="M5.38 11.6099L11.61 5.37988M16.5 8.5C16.5 12.9183 12.9183 16.5 8.5 16.5C4.08172 16.5 0.5 12.9183 0.5 8.5C0.5 4.08173 4.08172 0.5 8.5 0.5C12.9183 0.5 16.5 4.08173 16.5 8.5ZM7.44 5.93994C7.44 6.76836 6.76843 7.43994 5.94 7.43994C5.11158 7.43994 4.44 6.76836 4.44 5.93994C4.44 5.11151 5.11158 4.43994 5.94 4.43994C6.76843 4.43994 7.44 5.11151 7.44 5.93994ZM12.56 11.0601C12.56 11.8885 11.8884 12.5601 11.06 12.5601C10.2316 12.5601 9.56 11.8885 9.56 11.0601C9.56 10.2316 10.2316 9.56006 11.06 9.56006C11.8884 9.56006 12.56 10.2316 12.56 11.0601Z" stroke="black" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Zniżka wynika z: 
      </div>
      <div id="smart-cart-breakdown-subscription-row" 
      class="flex justify-between items-center mb-2 text-s"
>
        <span>Zakup w formie subskrypcji*</span>
        <span class="text-green text-xs font-semibold tracking-[0.24px] leading-[14.4px]" id="smart-cart-breakdown-subscription"></span>
      </div>
      <div id="smart-cart-breakdown-compare-row" class="flex justify-between items-center mb-2 text-s">
        <span>Obniżka ceny produktu</span>
        <span class="text-green text-xs font-semibold tracking-[0.24px] leading-[14.4px]" id="smart-cart-breakdown-compare"></span>
      </div>
      <div id="smart-cart-breakdown-code-row" class="flex justify-between items-center mb-3 text-s">
        <span>Zastosowany kod rabatowy*</span>
        <span class="text-green text-xs font-semibold tracking-[0.24px] leading-[14.4px]" id="smart-cart-breakdown-code"></span>
      </div>
      <div class="bg-gray40 h-[1px] mb-3"></div>
      <div class="flex justify-between gap-3 font-semibold text-sm items-center mb-5">
        <span>Suma zniżek</span>
        <span class="text-green text-xs font-semibold tracking-[0.24px] leading-[14.4px]"  id="smart-cart-breakdown-total"></span>
      </div>
      <div id="smart-cart-breakdown-subscription-note" class="hidden mt-2 font-normal text-xxs leading-[12px] tracking-[0.2px] text-gray100 ">
        *W pierwszym zamówieniu naliczymy korzystniejszy rabat (zniżka 15% za zakup subskrypcyjny lub kod rabatowy). W odnowieniu subskrypcji dodaj kod zniżkowy i <strong>łącz rabaty ze zniżką subskrypcyjną!</strong>
      </div>
      <div id="smart-cart-breakdown-code-note" class="hidden mt-2 font-normal text-xxs leading-[12px] tracking-[0.2px] text-gray100">
        *Naliczyliśmy najwyższą możliwą zniżkę dla wybranych produktów.
      </div>
    </div>
  `;

  document.body.appendChild(modal);

  const closeHandler = (event) => {
    const closeTarget = event.target.closest('[data-modal-close]');
    if (!closeTarget) return;
    modal.style.display = 'none';
  };

  modal.addEventListener('click', closeHandler);
  return modal;
};

const updateDiscountBreakdownModal = (discountBreakdown) => {
  const modal = ensureDiscountBreakdownModal();
  if (!modal) return;

  const total =
    discountBreakdown.subscriptionDiscount + discountBreakdown.compareAtDiscount + discountBreakdown.promoCodeDiscount;

  const subscriptionValue = modal.querySelector('#smart-cart-breakdown-subscription');
  const compareValue = modal.querySelector('#smart-cart-breakdown-compare');
  const codeValue = modal.querySelector('#smart-cart-breakdown-code');
  const totalValue = modal.querySelector('#smart-cart-breakdown-total');

  const subscriptionRow = modal.querySelector('#smart-cart-breakdown-subscription-row');
  const compareRow = modal.querySelector('#smart-cart-breakdown-compare-row');
  const codeRow = modal.querySelector('#smart-cart-breakdown-code-row');
  const subscriptionNote = modal.querySelector('#smart-cart-breakdown-subscription-note');
  const codeNote = modal.querySelector('#smart-cart-breakdown-code-note');

  if (subscriptionValue)
    subscriptionValue.innerText = '-' + formatPriceForDiscount(discountBreakdown.subscriptionDiscount);
  if (compareValue) compareValue.innerText = '-' + formatPriceForDiscount(discountBreakdown.compareAtDiscount);
  if (codeValue) codeValue.innerText = '-' + formatPriceForDiscount(discountBreakdown.promoCodeDiscount);
  if (totalValue) totalValue.innerText = '-' + formatPriceForDiscount(total);

  if (subscriptionRow) subscriptionRow.style.display = discountBreakdown.subscriptionDiscount > 0 ? 'flex' : 'none';
  if (compareRow) compareRow.style.display = discountBreakdown.compareAtDiscount > 0 ? 'flex' : 'none';
  if (codeRow) codeRow.style.display = discountBreakdown.promoCodeDiscount > 0 ? 'flex' : 'none';
  if (subscriptionNote) subscriptionNote.style.display = discountBreakdown.subscriptionDiscount > 0 ? 'block' : 'none';
  if (codeNote) codeNote.style.display = discountBreakdown.promoCodeDiscount > 0 ? 'block' : 'none';
};

const openDiscountBreakdownModal = () => {
  const modal = ensureDiscountBreakdownModal();
  if (!modal) return;
  modal.style.display = 'flex';
};

const checkIsPromoCodeValid = async (code) => {
  try {
    const { cartDiscountCodesUpdate } = await updateCartDiscountCodes(Rebuy.Cart.cart.token, code);
    if (cartDiscountCodesUpdate) {
      return cartDiscountCodesUpdate.cart.discountCodes[0].applicable;
    } else {
      return false;
    }
  } catch (e) {
    console.error(e);
    return false;
  }
};

const scrollToCartBottomPosition = () => {
  const cart = document.getElementById('flyout-cart-content');
  if (!cart) return;

  cart.scrollTo({
    top: cart.scrollHeight,
    behavior: 'smooth',
  });
};

const addDiscountCode = async (value, refresh = true) => {
  const isValid = await checkIsPromoCodeValid(value);
  if (!isValid) return;

  const code = value.toUpperCase();
  await Rebuy.SmartCart.applyDiscount(code);
  await fetch(`/checkout?discount=${code}`);

  if (refresh) {
    Rebuy.Cart.fetchCart();
  }
};

const removeAllDiscounts = async (target) => {
  if (target && target.disabled) return;

  if (target) {
    target.disabled = true;
  }

  let discountCode = undefined;
  if (Object.keys(target).includes('getAttribute')) {
    discountCode = target?.getAttribute('data-discount-code');
  }

  await Rebuy.SmartCart.removeDiscount();
  await Rebuy.Cart.removeDiscount();
  await fetch('/checkout?discount=CLEAR');
  Rebuy.Cart.fetchCart();
  setTimeout(expandDiscountInput, 500);

  dataLayerPromise({
    event: 'discount_code_deleted',
    discount_code_text: discountCode,
  });
  dataLayerPromise({
    event: 'discount_field_interaction',
    section: 'shopping_cart',
    element: 'promo_code_field',
    element_value: discountCode,
    interaction_type: 'remove',
  });
};

const expandDiscountInput = () => {
  const label = document.getElementById('smart-cart-discount-input-label');
  const wrapper = document.getElementById('smart-cart-discount-input-container');
  const input = document.getElementById('smart-cart-discount-input');

  if (!input) return;

  wrapper.classList.remove('hidden');
  label.classList.remove('design-link');
  label.classList.remove('hidden');
  setTimeout(() => input.focus(), 300);
};

const collapseDiscountInput = () => {
  const wrapper = document.getElementById('smart-cart-discount-input-container');
  const label = document.getElementById('smart-cart-discount-input-label');

  if (wrapper) wrapper.classList.add('hidden');
  if (label) label.classList.add('hidden');
  if (label) label.classList.remove('design-link');
};

const setDiscountInputLabelListener = () => {
  const label = document.getElementById('smart-cart-discount-input-label');
  if (!label) return;
  label.removeEventListener('click', expandDiscountInput);
  label.addEventListener('click', expandDiscountInput);
};

const blockInputButtonWhenInputIsEmpty = (e) => {
  const button = document.getElementById('smart-cart-discount-button');
  if (!button) return;
  if (e) {
    if (e.target.value) {
      button.removeAttribute('disabled');
    } else {
      button.setAttribute('disabled', 'disabled');
    }
  } else {
    const input = document.getElementById('smart-cart-discount-input');
    if (input?.value) {
      button?.removeAttribute('disabled');
    } else {
      button?.setAttribute('disabled', 'disabled');
    }
  }
};

const KeyDownInputHandler = (e) => {
  if (e.key === 'Enter') {
    addDiscountCodeFromInput();
  }
};

const setKeyDownInputListener = () => {
  const input = document.getElementById('smart-cart-discount-input');
  if (!input) return;

  input.removeEventListener('keydown', KeyDownInputHandler);
  input.addEventListener('keydown', KeyDownInputHandler);
  input.removeEventListener('keyup', blockInputButtonWhenInputIsEmpty);
  input.addEventListener('keyup', blockInputButtonWhenInputIsEmpty);
};

const setSmartCartSummaryListener = () => {
  const contentWrapper = document.getElementById('flyout-cart-content');
  if (!contentWrapper) return;
  contentWrapper.removeEventListener('scroll', collapseCartSummaryHandler);
  contentWrapper.addEventListener('scroll', collapseCartSummaryHandler);
};

const getDiscountCodeArrFromCartItems = () => {
  if (!Array.isArray(Rebuy.SmartCart.cart.items) || Rebuy.SmartCart.cart.items.length === 0) return null;

  function onlyUnique(value, index, array) {
    return array.indexOf(value) === index;
  }

  const arr = Rebuy.SmartCart.cart.items.flatMap(({ discounts }) => discounts.map(({ title }) => title));
  return arr.filter(onlyUnique);
};

const cartSummaryHandler = () => {
  const count = document.getElementById('smart-cart-product-count');
  const finalPrice = document.getElementById('smart-cart-final-price');
  const discountAmount = document.getElementById('smart-cart-discount-amount');
  const discountCodeList = document.getElementById('smart-cart-discounts-list');
  const discountWrapper = document.getElementById('smart-cart-discount-wrapper');
  const originalPriceTop = document.getElementById('smart-cart-original-price-top');
  const shippingPrices = document.querySelectorAll('.smart-cart-shipment-cost');
  const deliveryMessage = document.getElementById('smart-cart-summary-delivery-message');
  const originalPriceBottom = document.getElementById('smart-cart-original-price-bottom');
  const discountLabel = discountWrapper?.querySelector('.design-cart-label');

  const { digitalProductsTotalValue } = handleDigitalProductsInCart();
  const { item_count, total_price, original_total_price } = Rebuy.SmartCart.cart;
  const cartItems = Array.isArray(Rebuy.SmartCart.cart.items) ? Rebuy.SmartCart.cart.items : [];
  const discountBreakdown = getCartDiscountBreakdown(cartItems);
  const totalCalculatedDiscount =
    discountBreakdown.subscriptionDiscount + discountBreakdown.compareAtDiscount + discountBreakdown.promoCodeDiscount;
  const totalCalculatedDiscountWithoutCode =
    discountBreakdown.subscriptionDiscount + discountBreakdown.compareAtDiscount;

  const totalPriceWithoutDigital = total_price - digitalProductsTotalValue;
  const hasFreeShippingSub = Rebuy.SmartCart.hasFreeShipping();
  const hasFreeShippingForAll = totalPriceWithoutDigital / 100 > 150;
  const hasOnlyDigitalProducts = digitalProductsTotalValue > 0 && digitalProductsTotalValue === total_price;
  const hasFreeShipping = hasFreeShippingSub || hasFreeShippingForAll || hasOnlyDigitalProducts;
  const shippingCost = hasFreeShipping ? 0 : 1490;

  const codeArray = getDiscountCodeArrFromCartItems();
  const discountCode = codeArray?.length > 0 ? codeArray[0] : Rebuy.Cart.discount;

  const shippingMessageHandler = () => {
    const hasOnlySub = Rebuy.SmartCart.cart.items.every((item) => !!item.selling_plan_allocation);
    const hasOnlyOnetime = Rebuy.SmartCart.cart.items.every((item) => !item.selling_plan_allocation);

    let amount = 15000 - totalPriceWithoutDigital;
    if (hasOnlySub) amount = 6000 - totalPriceWithoutDigital;
    const notFreeShippingMsg = `Do darmowej dostawy brakuje Ci <strong>${formatPriceForDiscount(amount)}</strong>`;

    if (!deliveryMessage) return;

    if (hasFreeShipping) {
      deliveryMessage.classList.add('animation-wrapped');
      setTimeout(() => (deliveryMessage.textContent = ''), 310);
    } else {
      deliveryMessage.classList.remove('animation-wrapped');
      if (hasOnlySub) deliveryMessage.innerHTML = notFreeShippingMsg;
      else if (hasOnlyOnetime) deliveryMessage.innerHTML = notFreeShippingMsg;
      else deliveryMessage.innerHTML = notFreeShippingMsg + `. Zamień na subskrypcję z darmową dostawą od 60 zł`;
    }
  };

  const discountCodeUIHandler = () => {
    const breakdownButton = `<button type="button" id="${DISCOUNT_BREAKDOWN_BUTTON_ID}" class=""><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_5472_116810)">
    <path d="M8.00004 10.6654V7.9987M8.00004 5.33203H8.00671M14.6667 7.9987C14.6667 11.6806 11.6819 14.6654 8.00004 14.6654C4.31814 14.6654 1.33337 11.6806 1.33337 7.9987C1.33337 4.3168 4.31814 1.33203 8.00004 1.33203C11.6819 1.33203 14.6667 4.3168 14.6667 7.9987Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
    <clipPath id="clip0_5472_116810">
    <rect width="16" height="16" fill="white"/>
    </clipPath>
    </defs>
    </svg>

</button>`;
    const maxDiscountInfo = document.getElementById('smart-cart-max-discount-info');

    if (discountCode) {
      collapseDiscountInput();
      // dblclick użyty dla funkcji "blockCartActions", tylko jako state na funkcje
      const codeButton = `<button class="smart-cart-fetching-active design-discount-code disabled:smart-cart-action-disabled" data-cart-blocking="onclick" ondblclick="removeAllDiscounts(this)" data-discount-code="${discountCode}">${discountCode}</button>`;
      if (discountLabel) discountLabel.innerHTML = `zniżki ${breakdownButton} ${codeButton}`;
      if (discountCodeList) discountCodeList.innerHTML = codeButton;
      if (maxDiscountInfo) maxDiscountInfo.classList.remove('hidden');
    } else {
      if (window.prevDiscountCode) expandDiscountInput();
      if (discountLabel) discountLabel.innerHTML = `zniżki ${breakdownButton}`;
      if (discountCodeList) discountCodeList.innerHTML = null;
      if (maxDiscountInfo) maxDiscountInfo.classList.add('hidden');
    }
  };
  const originalPriceHandler = () => {
    const shouldShowOriginalPrice = original_total_price > total_price || totalCalculatedDiscountWithoutCode > 0;

    if (shouldShowOriginalPrice) {
      if (originalPriceTop) originalPriceTop.innerText = formatPriceForDiscount(original_total_price);
      if (originalPriceBottom) {
        const originalPriceBottomWithAllDiscounts =
          original_total_price + shippingCost + totalCalculatedDiscountWithoutCode;
        originalPriceBottom.innerText = formatPriceForDiscount(originalPriceBottomWithAllDiscounts);
      }
      // Debugging:
      // originalPriceBottom.innerText = `${formatPriceForDiscount(original_total_price)} (+${shippingCost})`;
    } else {
      if (originalPriceTop) originalPriceTop.innerText = formatPriceForDiscount(total_price);
      if (originalPriceBottom) originalPriceBottom.innerText = '';
    }
  };
  const totalDiscountHandler = () => {
    if (totalCalculatedDiscount > 0) {
      if (discountWrapper) discountWrapper.classList.remove('hidden');
      if (discountAmount) discountAmount.innerText = formatPriceForDiscount(totalCalculatedDiscount);
    } else {
      if (discountWrapper) discountWrapper.classList.add('hidden');
      if (discountAmount) discountAmount.innerText = formatPriceForDiscount(0);
    }
  };
  const shippingCostHandler = () => {
    shippingPrices.forEach((price) => (price.innerText = hasFreeShipping ? 'Darmowa' : formatPriceForDiscount(1490)));
  };
  const finalPriceHandler = () => {
    if (finalPrice) finalPrice.innerText = formatPriceForDiscount(total_price + shippingCost);
    // Debugging:
    // if (finalPrice) finalPrice.innerText = `${formatPriceForDiscount(total_price)} (+${shippingCost})`;
  };
  const counterHandler = () => {
    if (count) count.innerText = item_count > 0 ? `(${item_count})` : '';
  };

  shippingMessageHandler();
  discountCodeUIHandler();
  updateDiscountBreakdownModal(discountBreakdown);
  originalPriceHandler();
  totalDiscountHandler();
  shippingCostHandler();
  finalPriceHandler();
  counterHandler();

  window.prevDiscountCode = discountCode;
};

const addDiscountCodeToRebuyAfterReturnFormCheckout = () => {
  if (!Rebuy || !Rebuy?.SmartCart || !Rebuy.SmartCart?.cart?.items || !(Rebuy.SmartCart?.cart.items?.length > 0))
    return;
  if (!Rebuy.SmartCart?.cart.items[0].discounts || !(Rebuy.SmartCart?.cart.items[0].discounts.length > 0)) return;

  const code = Rebuy.SmartCart?.cart.items[0].discounts[0].title;
  const rebuyCode = Rebuy.SmartCart.discount?.code;

  if (code && (!rebuyCode || rebuyCode.toUpperCase() !== code.toUpperCase())) {
    addDiscountCode(code, false);
  }
};

const discountInputErrorHandler = (message) => {
  const input = document.getElementById('smart-cart-discount-input');
  const errMsg = document.getElementById('smart-cart-discount-input-error-msg');

  if (!input) return;

  if (message) {
    input.classList.add('code-error');
    errMsg.innerText = message;
  } else {
    if (input) input.classList.remove('code-error');
    if (errMsg) errMsg.innerText = null;
  }
};

const addDiscountCodeFromInput = async (e) => {
  const input = document.getElementById('smart-cart-discount-input');
  if (!input || !input.value) return null;

  const el = e?.target;

  if (el) el.disabled = true;
  input.disabled = true;

  let code = input.value.trim();
  const isValid = await checkIsPromoCodeValid(code);

  if (!isValid) {
    discountInputErrorHandler('Podany kod jest błędny lub nie może zostać zastosowany do produktów w koszyku.');
  } else {
    discountInputErrorHandler();
    await addDiscountCode(code);
    wasCodeAddedFromInput = true;
    input.value = '';
  }

  if (el) el.disabled = false;
  input.disabled = false;
  return { code, isValid };
};

const addDiscountCodeHandler = async (e) => {
  const { code, isValid } = (await addDiscountCodeFromInput(e)) ?? {};

  document.dispatchEvent(new CustomEvent('rebuy:cart.unblockElements'));

  if (isValid) {
    dataLayerPromise({
      event: 'discount_code_applied',
      discount_code_text: code,
    });
    dataLayerPromise({
      event: 'discount_field_interaction',
      section: 'shopping_cart',
      element: 'promo_code_field',
      element_value: code,
      interaction_type: 'apply',
    });
  } else {
    dataLayerPromise({
      event: 'discount_field_interaction',
      section: 'shopping_cart',
      element: 'promo_code_field',
      element_value: code,
      interaction_type: 'fail_apply',
    });
  }
};

const setDiscountInputButtonsListeners = () => {
  const clearInputHandler = () => discountInputErrorHandler();
  const removeAllDiscountsHandler = (e) => removeAllDiscounts(e.target);
  const openBreakdownModalHandler = () => openDiscountBreakdownModal();
  const input = document.getElementById('smart-cart-discount-input');
  const button = document.getElementById('smart-cart-discount-button');
  const removeButtons = document.querySelectorAll('button[data-discount-code]');
  const breakdownButton = document.getElementById(DISCOUNT_BREAKDOWN_BUTTON_ID);

  input?.removeEventListener('keydown', clearInputHandler);
  input?.addEventListener('keydown', clearInputHandler);
  button?.removeEventListener('click', addDiscountCodeHandler);
  button?.addEventListener('click', addDiscountCodeHandler);
  breakdownButton?.removeEventListener('click', openBreakdownModalHandler);
  breakdownButton?.addEventListener('click', openBreakdownModalHandler);
  removeButtons.forEach((btn) => btn?.removeEventListener('click', removeAllDiscountsHandler));
  removeButtons.forEach((btn) => btn?.addEventListener('click', removeAllDiscountsHandler));
};

const observePromoInputForAnalytics = () => {
  const promoInput = document.getElementById('smart-cart-discount-input');

  if (wasShowInputListenerSet) return;

  if (!promoInput) {
    console.warn('Element o id "promo_input" nie został znaleziony.');
    return;
  }

  const observer = new IntersectionObserver(
    (entries, observerInstance) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          dataLayerPromise({
            event: 'discount_field_interaction',
            section: 'shopping_cart',
            element: 'promo_code_field',
            element_value: '-',
            interaction_type: 'visible',
          });
          observerInstance.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.75,
    }
  );

  wasShowInputListenerSet = true;
  observer.observe(promoInput);
};

const updateCartDiscountCodes = async (cartId, code) => {
  const endpoint = 'https://yourkaya.myshopify.com/api/2025-01/graphql.json';
  const storefrontAccessToken = '10565dd8dd1387fe67f673e8b7444d07';

  const query = `
    mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
      cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
        cart {
          id
          discountCodes {
            code
            applicable
          }
        }
        userErrors {
          code
          field
          message
        }
        warnings {
          code
          message
          target
        }
      }
    }
  `;

  const variables = { cartId: `gid://shopify/Cart/${cartId}`, discountCodes: [code] };

  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
      },
      body: JSON.stringify({ query, variables }),
    });

    const result = await response.json();

    return result.data;
  } catch (error) {
    console.error('Błąd podczas wykonywania zapytania:', error);
    throw error;
  }
};

document.addEventListener('rebuy:cart.change', () => {
  setTimeout(cartSummaryHandler, 200);
  setTimeout(setKeyDownInputListener, 200);
  setTimeout(discountInputErrorHandler, 200);
  setTimeout(setSmartCartSummaryListener, 200);
  setTimeout(setDiscountInputLabelListener, 200);
  setTimeout(observePromoInputForAnalytics, 200);
  setTimeout(setDiscountInputButtonsListeners, 200);
  setTimeout(blockInputButtonWhenInputIsEmpty, 200);
});

document.addEventListener('rebuy:cart.ready', () => {
  setTimeout(cartSummaryHandler, 200);
  setTimeout(setKeyDownInputListener, 200);
  setTimeout(setSmartCartSummaryListener, 200);
  setTimeout(setDiscountInputLabelListener, 200);
  setTimeout(setDiscountInputButtonsListeners, 200);
  setTimeout(blockInputButtonWhenInputIsEmpty, 200);
  // setTimeout(addDiscountCodeToRebuyAfterReturnFormCheckout, 200);
});
